import React from 'react';
import IconFromPath from '../IconFromPath/IconFromPath';
import RegularPolygon from './RegularPolygon';

const RegularPolygonIcon = props => (
    <IconFromPath {...props} Path={RegularPolygon} />
);

export default RegularPolygonIcon;
